import styled from 'styled-components';
import { getBreakpointInsetSizing, getHideStyes } from '../helpers';
import { spacingDebugColors } from '../../../defaultTheme';
const InsetSpacer = styled.div `
  ${({ debug, top, left, bottom, right, respondToBreakpoints, hideOnBreakpointUp, hideOnBreakpointDown, hideOnlyOnBreakpoints }) => {
    const allSizes = [top, right, bottom, left];
    const all = `${top}px ${right}px ${bottom}px ${left}px;`;
    const insetStyle = debug ? 'border-width' : 'padding';
    const responsiveStyles = respondToBreakpoints &&
        respondToBreakpoints
            .map((breakpoint) => {
            return getBreakpointInsetSizing(allSizes, breakpoint, [insetStyle]);
        })
            .join(' ');
    let styles = responsiveStyles || '';
    const setHideStyles = debug ? 'border-width: 0;' : 'padding: 0;';
    styles += getHideStyes(hideOnBreakpointUp, hideOnBreakpointDown, hideOnlyOnBreakpoints, setHideStyles);
    if (debug) {
        return `
        border-color: ${spacingDebugColors.inset};
        border-style: solid;
        border-width: ${all};
        ${styles}
      `;
    }
    return `
      padding: ${all};
      ${styles}
    `;
}}
`;
export default InsetSpacer;
